module.exports = __webpack_public_path__ + "img/logo-desktop.e9b464bc.png";